import { render, staticRenderFns } from "./zijian_04.vue?vue&type=template&id=29635bd1&scoped=true&"
import script from "./zijian_04.vue?vue&type=script&lang=js&"
export * from "./zijian_04.vue?vue&type=script&lang=js&"
import style0 from "./zijian_04.vue?vue&type=style&index=0&id=29635bd1&prod&lang=less&"
import style1 from "./zijian_04.vue?vue&type=style&index=1&id=29635bd1&prod&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29635bd1",
  null
  
)

export default component.exports